import React from "react";
import PropTypes from "prop-types";
import withStyles from "@mui/styles/withStyles";
import MenuItem from "@mui/material/MenuItem";
import FormControl from "@mui/material/FormControl";
import Select from "@mui/material/Select";
import QuestionPreview from "../QuestionPreview";
import _ from "lodash";
import {
  moveArray,
  getRankingEndpoint,
  extractContent,
} from "../../../services/commons";
import Grid from "@mui/material/Grid";

import styles from "./styles";
import { withTranslation } from "react-i18next";
import { getTranslation } from "../../../locales";

export function createObjFromArray(arr) {
  const result = [];
  arr.forEach((item) => {
    const obj = {};
    obj["label"] = item;
    obj["value"] = item;
    result.push(obj);
  });
  return result;
}

class AnswerRanking extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      rankingOptions:
        (this.props.value &&
          this.props.value.length &&
          createObjFromArray(this.props.value)) ||
        this.props.rankingOptions?.filter(
          (item) => item.shouldRenderChoice !== false
        ),
      updated: this.props.value && this.props.value.length ? true : false,
    };
    this.handleChange = this.handleChange.bind(this);
  }

  handleChange = (newIndex, oldIndex) => {
    let newRankingOptions = _.cloneDeep(this.state.rankingOptions);
    newRankingOptions = moveArray(newRankingOptions, oldIndex, newIndex);
    this.setState({ rankingOptions: newRankingOptions, updated: true }, () => {
      const answerList = this.state.rankingOptions.map((item) => item.label);
      this.props.handleChange(answerList);
    });
  };

  componentDidUpdate(prevProps) {
    if (prevProps.value !== this.props.value) {
      const newRankingOptions =
        (this.props.value &&
          this.props.value.length &&
          createObjFromArray(this.props.value)) ||
        this.state.rankingOptions;
      this.setState({ rankingOptions: newRankingOptions, updated: true });
    }
  }

  render() {
    const { classes, endpoint = "worse_better", low, high } = this.props;
    const left =
      endpoint === "custom"
        ? low
        : getTranslation(
            this.props.currentLang,
            getRankingEndpoint(endpoint, "left")
          );
    const right =
      endpoint === "custom"
        ? high
        : getTranslation(
            this.props.currentLang,
            getRankingEndpoint(endpoint, "right")
          );

    return (
      <div>
        <fieldset aria-required={this.props.required}>
          <legend>
            <QuestionPreview
              question={
                this.props.question ||
                this.props.t("surveyTaker:rankingQuestion")
              }
              required={this.props.required}
              helperText={this.props.helperText}
            />
            <p
              className={classes.offscreenText}
            >{`Answer is in the form of a ranking 1 to ${this.state.rankingOptions.length}, with 1 being the ${this.props.low} and 4 being the ${this.props.high}. Answers will be arranged on each selection`}</p>
          </legend>
          <Grid className={classes.container}>
            <Grid>
              {this.state.rankingOptions.map(({ label }, optionIndex) => (
                <div key={optionIndex}>
                  <FormControl className={classes.formControl}>
                    <Select
                      variant="standard"
                      value={optionIndex}
                      onChange={(e) =>
                        this.handleChange(e.target.value, optionIndex)
                      }
                      classes={{ selectMenu: classes.selectMenu }}
                      data-testid="ranking-answer-select"
                      id={`${optionIndex}-${extractContent(
                        this.props.question.replace(/\s+/g, "")
                      )}`}
                      name={extractContent(
                        this.props.question.replace(/\s+/g, "")
                      )}
                      inputProps={{
                        "aria-label": `${optionIndex + 1}, ${label}`,
                        "aria-describedby": `${this.props.questionId}-error`,
                      }}
                    >
                      {this.state.rankingOptions.map((item, index) => (
                        <MenuItem
                          classes={{ root: classes.menuItem }}
                          key={index}
                          value={index}
                          data-testid="ranking-answer-menu"
                        >
                          <div>{index + 1}</div>
                        </MenuItem>
                      ))}
                    </Select>
                    <label
                      htmlFor={`${optionIndex}-${extractContent(
                        this.props.question.replace(/\s+/g, "")
                      )}`}
                      className={classes.label}
                    >
                      {label}
                    </label>
                  </FormControl>
                </div>
              ))}
            </Grid>
            {this.props.high && this.props.low && (
              <Grid className={classes.endPointsContainer}>
                <div className={classes.endPoints}>
                  <div className={classes.endPointsHigh}>{left}</div>
                  <div className={classes.endPointsLow}>{right}</div>
                </div>
                <div className={classes.endPonitIndicatorContainer}>
                  <div className={classes.endPonitIndicatorHorizontal}></div>
                  <div className={classes.endPonitIndicatorVerticale}></div>
                  <div className={classes.endPonitIndicatorHorizontal}></div>
                </div>
              </Grid>
            )}
          </Grid>
        </fieldset>
      </div>
    );
  }
}

AnswerRanking.propTypes = {
  classes: PropTypes.object.isRequired,
  question: PropTypes.string.isRequired,
  rankingOptions: PropTypes.array.isRequired,
  handleChange: PropTypes.func.isRequired,
};

AnswerRanking.defaultProps = {
  handleChange: () => {},
  required: false,
  rankingOptions: [],
  classes: {},
};

export default withStyles(styles)(
  withTranslation("surveyTaker")(AnswerRanking)
);
